import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PropTypes from "prop-types";

const AlertModal = ({ size, isOpen, title, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      size={size}
      contentClassName="generic-modal"
      centered
    >
      <ModalHeader>{title}</ModalHeader>
      {children && <ModalBody>{children}</ModalBody>}
    </Modal>
  );
};

AlertModal.propTypes = {
  size: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  children: PropTypes.any,
};

AlertModal.defaultProps = {
  size: "md",
};

export default AlertModal;
